import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { UrlModal } from "src/app/shared/url.model";
import { map } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class HosdocService {
  constructor(private httpClient: HttpClient) {}

  getSingleDoctorFromDb(id: string, token: string) {
    return this.httpClient
      .get<singleDoctorData>(UrlModal._URL + "/hos/gethosdocprofile/" + id)
      .pipe(
        map((res) => {
          if (res.status === 200) {
            return res.data;
          }
        })
      );
  }

  onDelete(id, token) {
    return this.httpClient.get(UrlModal._URL + "/hos/delhospitaldoc/" + id, {
      headers: new HttpHeaders({
        authorization: "Bearer " + token,
      }),
    });
  }
  onDisableLogin(id, token) {
    return this.httpClient.get<logindiabledData>(
      UrlModal._URL + "/hos/disabledlogindoc/" + id,
      {
        headers: new HttpHeaders({
          authorization: "Bearer " + token,
        }),
      }
    );
  }
  saveDoctorToDatabase(
    name: string,
    email: string,
    password: string,

    phoneNo: number,
    hospitalId,
    token: string
  ) {
    return this.httpClient.post(
      UrlModal._URL + "/ad/adminaddhosdoc",
      {
        name: name,
        email: email,
        password: password,

        phoneNo: phoneNo,
        isHospital: true,
        hospitalId: hospitalId,
      },
      {
        headers: new HttpHeaders({
          authorization: "Bearer " + token,
        }),
      }
    );
  }

  RegisterHosDoctorToDatabase(
    name: string,
    consFee,
    endTime,
    startTime,
    clinicDays,
    doctorType: string,
    email: string,
    experience: number,
    degree: string,

    line1: string,
    city: string,
    pincode: number,
    state: string,
    memberCouncil,
    patientLimit,

    phoneNo,
    password,
    memberCouncilId,
    hospitalId,
    token
  ) {
    return this.httpClient.post(
      UrlModal._URL + "/hos/addnewdoctor",
      {
        name: name,
        consFee:consFee,
        endTime:endTime,
        startTime:startTime,
        clinicDays:clinicDays,
        doctorType: doctorType,
        email: email,
        experience: experience,
        degree: degree,

        line1: line1,
        city: city,

        pincode: pincode,

        state: state,

        memberCouncil: memberCouncil,
        patientLimit: patientLimit,

        phoneNo: phoneNo,
        password: password,
        hospitalId: hospitalId,
        memberCouncilId: memberCouncilId,
      },
      {
        headers: new HttpHeaders({
          authorization: "Bearer " + token,
        }),
      }
    );
  }

  getDoctorFromDb(token, page, id) {
    let params = new HttpParams();
    params = params.append("page", page);
    params = params.append("limit", "10");
    console.log(params);
    return this.httpClient
      .post<DoctorData>(
        UrlModal._URL + "/hos/gethospitaldoc/",
        {
          id: id,
        },
        {
          headers: new HttpHeaders({
            authorization: "Bearer " + token,
          }),
          params: params,
        }
      )
      .pipe(
        map((res) => {
          return {
            docData: res.data.docs,
            page: res.data.page,
            total: res.data.total,
          };
        })
      );
  }

  /*setClinicTiming(startTime, endTime, id, token) {
    return this.httpClient
      .post(
        UrlModal._URL + "/doc/clinictiming",
        {
          startTime: startTime,
          endTime: endTime,
          doctorId: id
        },
        {
          headers: new HttpHeaders({
            authorization: "Bearer " + token
          })
        }
      )
      .pipe(res => {
        return res;
      });
  }
  setClinicData(weekdays, patientLimit, id,token) {
    return this.httpClient
      .post(
        UrlModal._URL + "/doc/updateclinicdata",
        {
          weekDays: weekdays,
          patientLimit: patientLimit,
          id:id
          
        },
        {
          headers: new HttpHeaders({
            authorization: "Bearer " + token
          })
        }
      )
      .pipe(res => {
        return res;
      });
  }


  verifyPhn() {
    return this.httpClient
      .post(UrlModal._URL + "/phn/phonenumverify", {})
      .pipe();
  }*/
}

export interface singleDoctorData {
  status: number;
  message: string;
  data: {
    _id: string;
    name: string;
    doctorType: {
      isDeleted: boolean;
      _id: string;
      name: string;
      createdAt: string;
      updatedAt: string;
      __v: number;
    };
    email: string;
    experience: number;
    password: string;
    degree: string[];
    address: { line1: string; city: string; pincode: number; state: string };
    clinic: string;
    profileStatus: {
      profile: boolean;
      dailyLimit: boolean;
      scheduling: boolean;
    };
    isPhoneVerified: boolean;
    isVerified: boolean;
    profileImage: string;
    phoneNo: number;
    createdAt: string;
    updatedAt: string;
    __v: number;
  };
}
export interface clinicTimingData {
  status: number;
  message: string;
  data: {
    patientLimit: number;
    patientNumber: number;
    appointmentNumber: number;
    isDeleted: boolean;
    isEnabled: boolean;
    _id: string;
    doctorId: string;
    __v: Number;
    createdAt: string;
    updatedAt: string;
  };

  /*    {"status":200,"message":"getting single doctor",
  "data":{"address":{"city":"NAJIBABAD","line1":"Near chowki najibabad","pincode":246763},
  "profileStatus":{"profile":true,"dailyLimit":true,"scheduling":true},
  "degree":["MBBS","MD","BDS","BUMS","BPHARMA"],"isDeleted":false,"isEnabled":true,"isPhoneVerified":true,"isVerified":true,"profileImage":"uploads/doctorImages/d1588345155184.jpeg","_id":"5e81aa36fcf9321474199b14","name":"Kabeer khan","email":"kabeer@yopmail.com","password":"$2a$10$o7JgHzCDJccXckhrUAjpLeBRYNcaWbd2IYMkpIJukjiWxPUMAgEsm","phoneNo":8923215936,"otp":3611,"otpExpDate":"2020-03-30T08:14:42.659Z","createdAt":"2020-03-30T08:13:42.661Z","updatedAt":"2020-05-20T10:22:43.922Z","__v":2
  ,"token":"eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjVlODFhYTM2ZmNmOTMyMTQ3NDE5OWIxNCIsImVtYWlsIjoia2FiZWVyQHlvcG1haWwuY29tIiwibmFtZSI6IkthYmVlciBraGFuIiwiemRlZ3JlZSI6WyJNQkJTIiwiTUQiLCJCRFMiLCJCVU1TIiwiQlBIQVJNQSJdLCJkb2N0b3JUeXBlIjoiNWUzMDY1NGRiMDQxMjg2YmI2NzhmM2U3IiwicHJvZmlsZVN0YXR1cyI6eyJwcm9maWxlIjp0cnVlLCJkYWlseUxpbWl0Ijp0cnVlLCJzY2hlZHVsaW5nIjp0cnVlfSwidXNlclR5cGUiOiJEQyIsImlhdCI6MTU4OTk3MDE2M30.j__V7_Gt_WmmlEmyWdusRndQzLxcPg2PK1vQ0gVZrGI","doctorType":{"isDeleted":true,"_id":"5e30654db041286bb678f3e7","name":"Gastrologist"
  ,"createdAt":"2020-01-28T16:46:05.492Z","updatedAt":"2020-05-12T16:02:22.468Z","__v":0},"clinic":"Kabeer clinic","experience":null}}

  

{"status":200,"message":"getting data","data":{"docs":[{"address":{"line1":"sec 19",
"city":"chandigarh","pincode":6756565,"state":"PB"},"isDeleted":false,"isEnabled":true,
"_id":"5e2fddcfb395323968cd0957","name":"sam","doctorType":"5e21c988d2ca201f6c76ab2a",
"email":"sam123@gm","password":"$2a$10$pqfJGRaNKYZqsXANBUU/mee1lzlcX7qeNizJSG.t85zltB801r.jS",
"degree":"MD","clinic":"healthcare","phoneNo":69696969696,
"createdAt":"2020-01-28T07:07:59.985Z",
"updatedAt":"2020-01-28T07:07:59.985Z","__v":0},
{"address":{"line1":"goregaon","city":"mumbai","pincode":67565656,"state":"MH"},
"isDeleted":false,"isEnabled":true,"_id":"5e2fe35fda0b213bf872551c","name":"chaya",
"doctorType":"5e21c991d2ca201f6c76ab2b",
"email":"chaya123@gm","password":"$2a$10$3coY4CXwkEhX3x/uq/KE2eleE0Smf3VV4EzTMidMajb8JyoM.H6dC",
"degree":"DM","clinic":"chaya clinic","phoneNo":6575675765,
"createdAt":"2020-01-28T07:31:43.009Z","updatedAt":"2020-01-29T13:17:31.289Z","__v":0}],
"total":2,"limit":10,"page":1,"pages":1}}











*/
}
export interface DoctorData {
  status: number;
  message: string;
  data: {
    docs: [
      {
        _id: string;
        name: string;
        doctorType: string;
        email: string;
        password: string;
        degree: [];
        profileStatus: {
          dailyLimit: false;
          scheduling: false;
        };
        address: {
          line1: string;
          city: string;
          pincode: number;
          state: string;
        };
        clinic: string;
        phoneNo: number;
        createdAt: string;
        updatedAt: string;
        consultationFee: { firstVisit: number };
        hospitalId: string;
        __v: number;
        isPhoneVerified: boolean;
      }
    ];
    total: number;
    limit: number;
    page: number;
    pages: number;
  };
}

/*consultationFee: {firstVisit: 0}
firstVisit: 0
createdAt: "2020-05-26T16:36:21.513Z"
degree: []
email: "nickey123@gmail.com"
hospitalId: "5ecd1334c3253828903a433d"
isDeleted: false
isEnabled: true
isPhoneVerified: false
isVerified: true
name: "nicky"
otpExpDate: "2020-05-26T16:37:21.486Z"
password: "$2a$10$GyWnYjD1UGy.BW2/EBpv..UlCzXc0YvA7QhyiKjQitcYSp4bNuZxu"
phoneNo: 7307315489
profileImage: null
profileStatus: {profile: false, dailyLimit: false, scheduling: false}
dailyLimit: false
profile: false
scheduling: false
updatedAt: "2020-05-26T16:36:21.513Z"
__v: 0
_id: "5ecd45858e69cd29507c8e85" */
export interface logindiabledData {
  status: number;
  message: string;
  isLoginDisabled: boolean;
}
